module.exports = "/packs/mokumoku-guide-image-f8b4408d959a873913d56716310ce06e.png";